import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';
import { InputBase, InputBaseProps } from '@spazious/dollhouse-uikit';

export interface InputTextProps extends InputBaseProps {}

export const InputText = styled(
  forwardRef<HTMLInputElement, InputTextProps>(({ type = 'text', ...restProps }, fowardedRef) => {
    return <InputBase ref={fowardedRef} type={type} {...(restProps as any)} />;
  })
).withConfig({
  displayName: 'InputText',
})<InputTextProps>``;
